// import React from 'react';

// const CustomRadioButton = ({ label, onChange, checked, ...props }) => {

//   return (
//     <div className="flex items-center mb-2">
//       <input
//         {...props}
//         type="radio"
//         className="form-radio h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
//         checked={checked}
//         onChange={onChange}
//       />
//       <label htmlFor={props.id || props.name} className="ml-2">
//         {label}
//       </label>
//     </div>
//   );
// };

// export default CustomRadioButton;

import React, { useState, useEffect } from 'react';

const CustomRadioButton = ({ label, onChange, isChecked, ...props }) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleRadioChange = (event) => {
    setChecked(event.target.checked);
    onChange && onChange(event);
  };

  return (
    <div className="flex items-center mb-2">
      <input
        {...props}
        type="radio"
        className="form-radio h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
        checked={checked}
        onChange={handleRadioChange}
      />
      <label htmlFor={props.id || props.name} className="ml-2">
        {label}
      </label>
    </div>
  );
};

export default CustomRadioButton;



